import { render } from "./ProgramTemplate.vue?vue&type=template&id=31999a63&scoped=true&ts=true"
import script from "./ProgramTemplate.vue?vue&type=script&lang=ts"
export * from "./ProgramTemplate.vue?vue&type=script&lang=ts"

import "./ProgramTemplate.vue?vue&type=style&index=0&id=31999a63&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31999a63"]])

export default __exports__